import type { LangCode } from '@/lib/i18n/lang';

/** Capitaale partner page locales (Top14 has no Slovenian → fallback to English). */
const TOP14_TO_CAPITALE: Partial<Record<LangCode, string>> = {
  sr: 'sr',
  'sr-cyrl': 'sr',
  en: 'en',
  de: 'de',
  ru: 'ru',
  tr: 'tr',
};

const PARTNER_QUERY = 'ref=top14&utm_source=top14&utm_medium=partner';

export function getCapitaalePartnerUrl(lang: LangCode): string {
  const capLang = TOP14_TO_CAPITALE[lang] ?? 'en';
  return `https://capitaale.com/${capLang}/partner/top14?${PARTNER_QUERY}`;
}
